{
  "clear": "Skaidrus",
  "invalid": "(netinkama)",
  "loading": "Įkeliama...",
  "noResults": "Be rezultatų",
  "valid": "(galioja)"
}
